<script setup>
import { ref, watch, computed, onMounted } from "vue"
import { useToast } from "vue-toastification"
import { useRouter } from "vue-router"

import Multiselect from "@vueform/multiselect"
import "@vueform/multiselect/themes/default.css"

import CKEditor from "@ckeditor/ckeditor5-vue"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import "@ckeditor/ckeditor5-build-classic/build/translations/fa"
import DropZone from "@/components/widgets/dropZone"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import store from "../../state/store"
import usePersianTools from "../../use/usePersianTools"

// Get toast interface
const toast = useToast()

const { convertPersianToEnglish } = usePersianTools()

const title = "ویرایش محصول"
const items = ref([
  {
    text: "داشبورد",
    href: "/",
  },
  {
    text: "ویرایش محصول",
    active: true,
  },
])

const props = defineProps({
  id: {
    require: true,
    type: String,
  },
})

const product = ref([])
const errors = ref({})
const loading = ref(false)
const router = useRouter()

const allCategories = computed(() =>
  store.state.allCategories.data.map((item) => {
    return {
      value: item.id,
      label: item.name,
    }
  })
)

const allTags = computed(() =>
  store.state.allTags.data.map((item) => {
    return {
      value: item.id,
      label: item.title,
    }
  })
)

/**
 *! start file
 */

let files = ref([])
let dropzoneFile = ref("")

const drop = (e) => {
  dropzoneFile.value = e.dataTransfer.files[0]
  files.value.push(dropzoneFile.value)
}
const selectedFile = () => {
  dropzoneFile.value = document.querySelector(".dropzoneFile").files[0]
  files.value.push(dropzoneFile.value)

  // console.log(files.value)
}
watch(
  () => [...files.value],
  (currentValue) => {
    return currentValue
  }
)

const deleteRecord = (ele, fileName, fileId = null) => {
  // ele.target.parentElement.parentElement.parentElement.remove();

  if (fileId !== null) {
    store.dispatch("deleteGallery", fileId).then((res) => {
      //console.log(res);
    })

    const index = productGallery.value.indexOf(
      productGallery.value.find((file) => file.uuid === fileId)
    )

    if (index > -1) {
      productGallery.value.splice(index, 1)
    }
  }

  const index = files.value.indexOf(
    files.value.find((file) => file.name === fileName)
  )

  if (index > -1) {
    files.value.splice(index, 1)
  }
}

const onFileChange = (event) => {
  product.value.product_image = event.target.files[0]
}

/**
 *! end file
 */

/**
 *! start editor
 */

const editorConfig = {
  language: "fa",
  toolbar: [
    "undo",
    "redo",
    "|",
    "heading",
    "|",
    "bold",
    "italic",
    "-", // break point
    "|",
    "alignment",
    "link",
    "|",
    "bulletedList",
    "numberedList",
  ],
  ckfinder: {
    options: {
      language: "fa",
    },
  },
}

const editor = ClassicEditor
const ckeditor = CKEditor.component

/**
 *! end editor
 */

const selectedStatus = ref("0")
const selectedCategory = ref("")
const productGallery = ref([])
const selectedTags = ref([])

const calculateDiscountPrice = () => {
  const price = parseFloat(product.value.product_price)
  const discount = parseFloat(product.value.discount_percent)
  if (!isNaN(price) && !isNaN(discount)) {
    return price * (1 - discount / 100)
  } else {
    return ""
  }
}

const calculateIncredibleOfferDiscountPrice = () => {
  const price = parseFloat(product.value.product_price)
  const discount = parseFloat(product.value.incredible_offer_discount_percent)
  if (!isNaN(price) && !isNaN(discount)) {
    return price * (1 - discount / 100)
  } else {
    return ""
  }
}

const discount_price = computed(() => calculateDiscountPrice())
const incredible_offer_discount_price = computed(() =>
  calculateIncredibleOfferDiscountPrice()
)

onMounted(async () => {
  try {
    loading.value = true
    await store.dispatch("getAllCategories")
    await store.dispatch("getAllTags")
    const { data } = await store.dispatch("getProduct", props.id)
    product.value = {
      ...data.data,
      discount_price: calculateDiscountPrice(),
      incredible_offer_discount_price: calculateIncredibleOfferDiscountPrice(),
    }
    if (product.value.long_description === null) {
    product.value.long_description = "";
  }
    selectedStatus.value = data.data.status ? "1" : "0"
    selectedCategory.value = data.data.category_id.toString()
    fetchAttributes(selectedCategory.value)
    productGallery.value = Object.values(data.data.product_gallery)
    selectedTags.value = data.data.tags.map((e) => e.id)

    /* productGallery.value.map((item) => {
    console.log(item.original_url);
  }) */
  } catch (error) {
    console.error("An error occurred:", error)
  } finally {
    loading.value = false
  }
})

watch(
  () => product.value.product_price,
  () => {
    product.value.discount_price = calculateDiscountPrice()
  }
)

watch(
  () => product.value.discount_percent,
  () => {
    product.value.discount_price = calculateDiscountPrice()
  }
)

watch(
  () => product.value.product_price,
  () => {
    product.value.incredible_offer_discount_price =
      calculateIncredibleOfferDiscountPrice()
  }
)

watch(
  () => product.value.incredible_offer_discount_percent,
  () => {
    product.value.incredible_offer_discount_price =
      calculateIncredibleOfferDiscountPrice()
  }
)

const selectedValues = ref({})
const categoryAttributes = ref([])

const onCategoryChange = async () => {
  selectedValues.value = {}
  await fetchAttributes(selectedCategory.value)
}

const fetchAttributes = async (categoryId) => {
  await store.dispatch("getCategoryAttributes", categoryId)
  const data = computed(() => store.state.categoryAttributes.data)
  categoryAttributes.value = data.value.filter((attr) => attr.values.length > 0)

  /* categoryAttributes.value.map((attr) => {
    selectedValues.value[attr.id] = attr.values[0].id
  }) */

  categoryAttributes.value.map((attr) => {
    const value = product.value.values.find((v) => v.attribute_id === attr.id)
    selectedValues.value[attr.id] = value
      ? value.value_id.toString()
      : attr.values[0].id
  })
}

const onSubmit = () => {
  loading.value = true
  if (product.value.id) {
    product.value.category_id = selectedCategory.value
    product.value.status = selectedStatus.value
    store
      .dispatch("updateProduct", {
        product,
        value_id: Object.values(selectedValues.value),
        tag_id: selectedTags.value,
        product_gallery: files.value,
      })
      .then((response) => {
        loading.value = false
        if (response.status === 200) {
          router.push({ name: "product.products" })
          toast.success("محصول با موفقیت به روزرسانی شد!", {
            timeout: 4000,
          })
        }
      })
      .catch((err) => {
        loading.value = false
        errors.value = err.response.data.errors
      })
  } else {
    console.log("Error")
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-row>
        <b-col lg="8">
          <form @submit.prevent="onSubmit" enctype="multipart/form-data">
            <b-card no-body>
              <b-card-body>
                <div class="mb-3">
                  <label class="form-label" for="product_name">نام محصول</label>
                  <input
                    type="text"
                    class="form-control"
                    id="product_name"
                    placeholder="نام محصول را وارد کنید"
                    v-model="product.product_name"
                  />
                  <div v-if="errors">
                    <div class="invalid-feedback" v-if="errors.product_name">
                      <span>{{ errors.product_name[0] }}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <label class="form-label">توضیحات محصول</label>
                  <ckeditor
                    v-model="product.long_description"
                    :editor="editor"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
              </b-card-body>
            </b-card>

            <b-card no-body>
              <b-card-header>
                <h5 class="card-title mb-0">گالری تصاویر محصول</h5>
              </b-card-header>
              <b-card-body>
                <div class="mb-4">
                  <h5 class="fs-14 mb-1">تصویر محصول</h5>
                  <p class="text-muted">تصویر اصلی محصول را اضافه کنید.</p>
                  <input
                    class="form-control"
                    id="product-image-input"
                    type="file"
                    accept="image/png, image/gif, image/jpeg"
                    @change="onFileChange"
                  />
                  <img
                    class="img-thumbnail my-2"
                    :alt="product.product_name"
                    width="150"
                    :src="product.product_image"
                    data-holder-rendered="true"
                  />
                  <div v-if="errors">
                    <div class="invalid-feedback" v-if="errors.product_image">
                      <span>{{ errors.product_image[0] }}</span>
                    </div>
                  </div>
                </div>
                <div class="vstack gap-2">
                  <h5 class="fs-14 mb-1">گالری تصاویر محصول</h5>
                  <p class="text-muted">افزودن تصاویر گالری محصول.</p>
                  <DropZone @drop.prevent="drop" @change="selectedFile" />

                  <div v-if="productGallery.length > 0">
                    <div
                      class="border rounded mb-1"
                      v-for="(gallery, index) of productGallery"
                      :key="index"
                    >
                      <div class="d-flex align-items-center p-2">
                        <div class="flex-grow-1">
                          <div class="pt-1">
                            <img
                              class="img-thumbnail my-1"
                              :alt="gallery.name"
                              width="75"
                              :src="gallery.original_url"
                              data-holder-rendered="true"
                            />
                            <h5 class="fs-14 mb-1" data-dz-name="">
                              {{ gallery.name }}
                            </h5>
                            <p class="fs-13 text-muted mb-0" data-dz-size="">
                              <strong>{{ gallery.size / 1024 }}</strong> کیلو
                              بایت
                            </p>
                            <strong
                              class="error text-danger"
                              data-dz-errormessage=""
                            ></strong>
                          </div>
                        </div>
                        <div class="flex-shrink-0 ms-3">
                          <b-button
                            data-dz-remove=""
                            variant="danger"
                            size="sm"
                            @click="
                              (ele) => {
                                deleteRecord(ele, gallery.name, gallery.uuid)
                              }
                            "
                          >
                            حذف
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="border rounded"
                    v-for="(file, index) of files"
                    :key="index"
                  >
                    <div class="d-flex align-items-center p-2">
                      <div class="flex-grow-1">
                        <div class="pt-1">
                          <h5 class="fs-14 mb-1" data-dz-name="">
                            {{ file.name }}
                          </h5>
                          <p class="fs-13 text-muted mb-0" data-dz-size="">
                            <strong>{{ file.size / 1024 }}</strong> کیلو بایت
                          </p>
                          <strong
                            class="error text-danger"
                            data-dz-errormessage=""
                          ></strong>
                        </div>
                      </div>
                      <div class="flex-shrink-0 ms-3">
                        <b-button
                          data-dz-remove=""
                          variant="danger"
                          size="sm"
                          @click="
                            (ele) => {
                              deleteRecord(ele, file.name)
                            }
                          "
                        >
                          حذف
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-card>

            <b-card no-body>
              <b-card-header>
                <ul
                  class="nav nav-tabs-custom card-header-tabs border-bottom-0"
                  role="tablist"
                >
                  <li class="nav-item">
                    <b-link
                      class="nav-link active"
                      data-bs-toggle="tab"
                      href="#addproduct-general-info"
                      role="tab"
                    >
                      اطلاعات کلی
                    </b-link>
                  </li>
                  <li class="nav-item">
                    <b-link
                      class="nav-link"
                      data-bs-toggle="tab"
                      href="#addproduct-metadata"
                      role="tab"
                    >
                      داده های متا
                    </b-link>
                  </li>
                </ul>
              </b-card-header>
              <b-card-body>
                <div class="tab-content">
                  <div
                    class="tab-pane active"
                    id="addproduct-general-info"
                    role="tabpanel"
                  >
                    <b-row>
                      <b-col>
                        <b-row>
                          <b-col sm="6">
                            <div class="mb-3">
                              <label class="form-label" for="product_inventory"
                                >موجودی</label
                              >
                              <div class="input-group mb-3">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="product_inventory"
                                  placeholder="موجودی را وارد کنید"
                                  v-model="product.product_inventory"
                                  @input="
                                    convertPersianToEnglish(
                                      $event.target.value,
                                      product,
                                      'product_inventory'
                                    )
                                  "
                                />
                              </div>
                              <div v-if="errors">
                                <div
                                  class="invalid-feedback"
                                  v-if="errors.product_inventory"
                                >
                                  <span>{{ errors.product_inventory[0] }}</span>
                                </div>
                              </div>
                            </div>
                          </b-col>

                          <b-col sm="6">
                            <div class="mb-3">
                              <label class="form-label" for="product_price"
                                >قیمت</label
                              >
                              <div class="input-group mb-3">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="product_price"
                                  placeholder="قیمت را وارد کنید"
                                  v-model="product.product_price"
                                  @input="
                                    convertPersianToEnglish(
                                      $event.target.value,
                                      product,
                                      'product_price'
                                    )
                                  "
                                />
                              </div>
                              <div
                                class="invalid-feedback text-primary text-opacity-75"
                              >
                                <span>{{ product.product_price_words }}</span>
                              </div>
                              <div v-if="errors">
                                <div
                                  class="invalid-feedback"
                                  v-if="errors.product_price"
                                >
                                  <span>{{ errors.product_price[0] }}</span>
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-row>
                          <b-col sm="6">
                            <div class="mb-3">
                              <label class="form-label" for="discount_percent"
                                >تخفیف (درصد تخفیف)</label
                              >
                              <div class="input-group mb-3">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="discount_percent"
                                  placeholder="درصد تخفیف را وارد کنید"
                                  v-model="product.discount_percent"
                                  @input="
                                    convertPersianToEnglish(
                                      $event.target.value,
                                      product,
                                      'discount_percent'
                                    )
                                  "
                                />
                              </div>
                              <div v-if="errors">
                                <div
                                  class="invalid-feedback"
                                  v-if="errors.discount_percent"
                                >
                                  <span>{{ errors.discount_percent[0] }}</span>
                                </div>
                              </div>
                            </div>
                          </b-col>
                          <b-col sm="6">
                            <div class="mb-3">
                              <label class="form-label" for="discount_price"
                                >قیمت با تخفیف</label
                              >
                              <div class="input-group mb-3">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="discount_price"
                                  placeholder="قیمت با تخفیف را وارد کنید"
                                  v-model="discount_price"
                                />
                              </div>
                              <div v-if="errors">
                                <div
                                  class="invalid-feedback"
                                  v-if="errors.discount_price"
                                >
                                  <span>{{ errors.discount_price[0] }}</span>
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row class="mt-3">
                      <b-col>
                        <b-row>
                          <b-col sm="4">
                            <div
                              class="form-check form-switch form-switch-secondary form-switch-md mb-3"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="featured"
                                v-model="product.featured"
                              />
                              <label class="form-check-label" for="featured"
                                >محصول ویژه</label
                              >

                              <div v-if="errors">
                                <div
                                  class="invalid-feedback"
                                  v-if="errors.featured"
                                >
                                  <span>{{ errors.featured[0] }}</span>
                                </div>
                              </div>
                            </div>
                          </b-col>
                          <b-col sm="4">
                            <div
                              class="form-check form-switch form-switch-secondary form-switch-md mb-3"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="special_sale"
                                v-model="product.special_sale"
                              />
                              <label class="form-check-label" for="special_sale"
                                >فروش ویژه</label
                              >

                              <div v-if="errors">
                                <div
                                  class="invalid-feedback"
                                  v-if="errors.special_sale"
                                >
                                  <span>{{ errors.special_sale[0] }}</span>
                                </div>
                              </div>
                            </div>
                          </b-col>
                          <b-col sm="4">
                            <div
                              class="form-check form-switch form-switch-secondary form-switch-md mb-3"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="incredible_offer"
                                v-model="product.incredible_offer"
                              />
                              <label
                                class="form-check-label"
                                for="incredible_offer"
                                >پیشنهاد شگفت انگیز</label
                              >

                              <div v-if="errors">
                                <div
                                  class="invalid-feedback"
                                  v-if="errors.incredible_offer"
                                >
                                  <span>{{ errors.incredible_offer[0] }}</span>
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row class="mt-3" v-if="product.incredible_offer">
                      <b-col>
                        <b-row>
                          <b-col sm="4">
                            <div class="mb-3">
                              <label
                                class="form-label"
                                for="incredible_offer_discount_percent"
                                >تخفیف شگفت انگیز (درصد)</label
                              >
                              <div class="input-group mb-3">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="incredible_offer_discount_percent"
                                  placeholder="درصد تخفیف را وارد کنید"
                                  v-model="
                                    product.incredible_offer_discount_percent
                                  "
                                  @input="
                                    convertPersianToEnglish(
                                      $event.target.value,
                                      product,
                                      'incredible_offer_discount_percent'
                                    )
                                  "
                                />
                                <div v-if="errors">
                                  <div
                                    class="invalid-feedback"
                                    v-if="
                                      errors.incredible_offer_discount_percent
                                    "
                                  >
                                    <span>{{
                                      errors
                                        .incredible_offer_discount_percent[0]
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-col>
                          <b-col sm="4">
                            <div class="mb-3">
                              <label
                                class="form-label"
                                for="incredible_offer_discount_price"
                                >تخفیف شگفت انگیز (قیمت)</label
                              >
                              <div class="input-group mb-3">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="incredible_offer_discount_price"
                                  placeholder="قیمت با تخفیف را وارد کنید"
                                  v-model="incredible_offer_discount_price"
                                />
                                <div v-if="errors">
                                  <div
                                    class="invalid-feedback"
                                    v-if="
                                      errors.incredible_offer_discount_price
                                    "
                                  >
                                    <span>{{
                                      errors.incredible_offer_discount_price[0]
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-col>
                          <b-col sm="4">
                            <div class="mb-3">
                              <label
                                class="form-label"
                                for="incredible_offer_hour"
                                >مدت زمان شگفت انگیز (ساعت)</label
                              >
                              <div class="input-group mb-3">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="incredible_offer_hour"
                                  placeholder="یک عدد صحیح وارد کنید"
                                  v-model="product.incredible_offer_hour"
                                  @input="
                                    convertPersianToEnglish(
                                      $event.target.value,
                                      product,
                                      'incredible_offer_hour'
                                    )
                                  "
                                />
                                <div v-if="errors">
                                  <div
                                    class="invalid-feedback"
                                    v-if="errors.incredible_offer_hour"
                                  >
                                    <span>{{
                                      errors.incredible_offer_hour[0]
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>

                  <div
                    class="tab-pane"
                    id="addproduct-metadata"
                    role="tabpanel"
                  >
                    <b-row>
                      <b-col lg="6">
                        <div class="mb-3">
                          <label class="form-label" for="meta_title"
                            >عنوان متا</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            placeholder="عنوان متا را وارد کنید"
                            id="meta_title"
                            v-model="product.meta_title"
                          />
                          <div v-if="errors">
                            <div
                              class="invalid-feedback"
                              v-if="errors.meta_title"
                            >
                              <span>{{ errors.meta_title[0] }}</span>
                            </div>
                          </div>
                        </div>
                      </b-col>

                      <b-col lg="6">
                        <div class="mb-3">
                          <label class="form-label" for="meta_keywords"
                            >کلمه های کلیدی متا</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            placeholder="کلمات کلیدی متا را وارد کنید"
                            id="meta_keywords"
                            v-model="product.meta_keywords"
                          />
                          <div v-if="errors">
                            <div
                              class="invalid-feedback"
                              v-if="errors.meta_keywords"
                            >
                              <span>{{ errors.meta_keywords[0] }}</span>
                            </div>
                          </div>
                        </div>
                      </b-col>
                    </b-row>

                    <div>
                      <label class="form-label" for="meta_description"
                        >توضیحات متا</label
                      >
                      <textarea
                        class="form-control"
                        id="meta_description"
                        placeholder="توضیحات متا را وارد کنید"
                        rows="3"
                        v-model="product.meta_description"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-card>
            <div class="text-end mb-3">
              <b-button type="submit" variant="success" class="w-sm"
                >ویرایش</b-button
              >
            </div>
          </form>
        </b-col>

        <b-col lg="4">
          <b-card no-body>
            <b-card-header>
              <h5 class="card-title mb-0">انتشار</h5>
            </b-card-header>
            <b-card-body>
              <div class="mb-3">
                <label for="status" class="form-label">وضعیت</label>
                <Multiselect
                  class="form-control"
                  v-model="selectedStatus"
                  :close-on-select="true"
                  :searchable="true"
                  :create-option="true"
                  :options="[
                    { value: '0', label: 'عدم انتشار' },
                    { value: '1', label: 'انتشار' },
                  ]"
                />
                <div v-if="errors">
                  <div class="invalid-feedback" v-if="errors.status">
                    <span>{{ errors.status[0] }}</span>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-card>

          <b-card no-body>
            <b-card-header>
              <h5 class="card-title mb-0">دسته بندی محصول</h5>
            </b-card-header>
            <b-card-body>
              <p class="text-muted mb-2">یک دسته انتخاب کنید</p>

              <Multiselect
                class="form-control"
                v-model="selectedCategory"
                :searchable="true"
                :options="allCategories"
                placeholder="یک دسته‌ بندی انتخاب کنید"
                @select="onCategoryChange"
              />
              <div v-if="errors">
                <div class="invalid-feedback" v-if="errors.category_id">
                  <span>{{ errors.category_id[0] }}</span>
                </div>
              </div>
            </b-card-body>
          </b-card>

          <b-card no-body v-if="selectedCategory">
            <b-card-header>
              <h5 class="card-title mb-0">ویژگی ها</h5>
            </b-card-header>
            <b-card-body>
              <div
                v-for="(attribute, index) in categoryAttributes"
                :key="index"
              >
                <label for="" class="form-label">{{ attribute.name }}:</label>
                <select
                  class="form-select mb-3"
                  v-model="selectedValues[attribute.id]"
                >
                  <option
                    v-for="value in attribute.values"
                    :key="value.id"
                    :value="value.id"
                  >
                    {{ value.value_name }}
                  </option>
                </select>
              </div>
              <div v-if="errors">
                <div class="invalid-feedback" v-if="errors.valueId">
                  <span>{{ errors.valueId[0] }}</span>
                </div>
              </div>
            </b-card-body>
          </b-card>

          <b-card no-body>
            <b-card-header>
              <h5 class="card-title mb-0">برچسب های محصول</h5>
            </b-card-header>
            <b-card-body>
              <p class="text-muted mb-2">یک یا چند برچسب انتخاب کنید</p>

              <Multiselect
                class="form-control"
                v-model="selectedTags"
                mode="tags"
                :searchable="true"
                :create-option="false"
                :close-on-select="false"
                :options="allTags"
                placeholder="یک یا چند برچسب انتخاب کنید"
              />
              <div v-if="errors">
                <div class="invalid-feedback" v-if="errors.tagId">
                  <span>{{ errors.tagId[0] }}</span>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>
  </Layout>
</template>
